webpackJsonp([2940368062224],{

/***/ 413:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ApplyPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageHeader = __webpack_require__(12);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(413);
	
	var _links = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyContent = [
	// {
	//   title: "Club",
	//   links: [
	//     { name: "Infosession", href: infoCLUB},
	//   ]
	// },
	// {
	//   title: "Decals",
	//   links: [
	//     { name: "Intro to Photoshop & Illustrator", href: applyDecalAI },
	//     { name: "Graphic Design Principles", href: applyDecalGDP },
	//     { name: "Photography Principles", href: applyDecalPHOTO },
	//   ]
	// },
	// {
	//   title: "Club",
	//   links: [
	//     { name: "Infosession", href: infoCLUB},
	//     { name: "Design: Blue", href:  applyClub_DESIGN_BLUE},
	//     { name: "Design: Gold", href:  applyClub_DESIGN_GOLD},
	//     { name: "Photo", href:  applyClub_PHOTO},
	//     { name: "Web", href:  applyClub_WEB},
	//   ]
	// },
	// {
	//   title: "For Organizations",
	//   links: [
	//     { name: "Partner", href: applyPartner },
	//   ]
	// },
	{
	  title: "For Clients",
	  links: [{ name: "Submit a request", href: _links.applyRequest }]
	}];
	
	function Apply(props) {
	  function LinkRow(props) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__row', style: { justifyContent: "flex-start" } },
	      _react2.default.createElement(
	        'h3',
	        { className: 'row__title' },
	        props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'g__flex__col' },
	        props.links.map(function (link) {
	          return _react2.default.createElement(
	            'a',
	            { className: 'g__ex__link col__item', href: link.href, target: '_blank' },
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              'h4',
	              null,
	              link.name,
	              ' \u2192'
	            )
	          );
	        })
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.content.map(function (linkrow) {
	      return _react2.default.createElement(LinkRow, {
	        title: linkrow.title,
	        links: linkrow.links
	      });
	    })
	  );
	}
	
	function ApplyPage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__page__wrapper apply' },
	    _react2.default.createElement(_PageHeader2.default, {
	      pageIndicator: 'Apply',
	      title: 'We want you to join us',
	      description: 'Club applications have closed. We are still accepting client and partnership requests!'
	    }),
	    _react2.default.createElement(Apply, { content: applyContent })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-apply-js-4b6b11ab8fad7f6d470c.js